export enum FeatureFlags {
  AUTOMATED_CENSUS_INGESTION = 'automated-census-ingestion',
  CARRIER_MEMBER_ID_BULK_IMPORT = 'carrier-member-id-bulk-import',
  CENSUS_FILTERS_V2_BY_ACCOUNT = 'census-filters-v2-by-account',
  CENSUS_NEWFRONT_ENABLED_USERS = 'census-newfront-enabled-users',
  EXP_REPORT_BY_ACCOUNT = 'exp-report-by-account',
  NOVA_COMPARE_DISABILITY = 'nova-compare-disability',
  NOVA_EXTRACT_DISABILITY = 'nova-extract-disability',
  NOVA_COMPARE_LIFE_ADD = 'nova-compare-life-add',
  NOVA_EXTRACT_LIFE_ADD = 'nova-extract-life-add',
  PARTNERS_MANAGEMENT = 'partners-management-dev',
  EMPLOYEE_WEB_PAGE_UPSERT_METHODS_ENABLED = 'employee-web-page-upsert-methods-enabled',
  TOTAL_REWARDS_CONTRACT_COMPARISON_ENABLED = 'tr-contract-comparison-enabled',
  CENSUS_PLAN_AND_COVERAGE_TIER_MAPPING = 'census-plan-and-coverage-tier-mapping',
  EWP_RESOURCES_PAGE_LINK_SECTIONS_ENABLED = 'ewp-resources-page-link-sections',
  COPY_TEMPLATE_WEB_PAGE_CONTENT_ENABLED = 'copy-template-web-page-content',
  DEMO_CLIENT_NAV_BUTTONS = 'demo-client-nav-buttons',
  CENSUS_MAPPING_REVAMP = 'census-mapping-revamp',
}
